export default {
  quick_links: {
    title: 'Quick Links',
    developers: 'Developers',
    agencies: 'Agencies',
    properties: 'Properties',
  },
  company: {
    title: 'Company',
    about_services: 'About Service',
    news: 'News',
    statistic: 'Statistics',
  },
  support: {
    title: 'Support',
  },
  get_in_touch: 'Get in Touch',
  email: 'info(at)estimator24.com',
  phone: '+41762378017',
  copyright: 'Estimator24.com'
}
